import React, { createContext, useContext, useEffect, useState } from "react";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import useAuthUser from "./hooks/useAuthUser";
import defaultUserData from "./config/defaultUserData";

const UserDataContext = createContext();

export const useUserData = () => useContext(UserDataContext);

export const UserDataProvider = ({ children }) => {
  const user = useAuthUser();
  const [userData, setUserData] = useState(null);
  const db = getFirestore();

  useEffect(() => {
    console.log("[UserDataContext] useAuthUser() 返回 user:", user);
    const fetchData = async () => {
      if (user) {
        const ref = doc(db, "users", user.uid);
        let snap = await getDoc(ref);
        if (!snap.exists()) {
          // 取得 nickname，優先用 user.displayName，其次用 localStorage 暫存
          let nickname =
            user.displayName || localStorage.getItem("register_nickname") || "";
          const mock = {
            ...defaultUserData,
            nickname,
            email: user.email,
          };
          await setDoc(ref, mock);
          setUserData(mock);
          console.log("[UserData] 新用戶 mock data:", mock);
        } else {
          setUserData(snap.data());
          console.log("[UserData] 現有用戶資料:", snap.data());
        }
      } else {
        setUserData(null);
        console.log("[UserData] 未登入，userData 設為 null");
      }
    };
    fetchData();
  }, [user, db]);

  return (
    <UserDataContext.Provider value={userData}>
      {children}
    </UserDataContext.Provider>
  );
};
